import * as actionTypes from '../types/decision';

const initialState = {
  pieceDecision: {},
  okRequest: false,
  error: false,
  loadingData: false,
  okUpdate: false,
  decisionsList: {
    data: [],
    loading: false
  },
  okHoldOn: false,
  okSave: false,
  okDecline: false,
  okAccept: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_DECISION:
      return {
        ...state,
        pieceDecision: {},
        okRequest: false,
        okUpdate: false,
        error: false,
        loadingData: true
      };

    case actionTypes.GET_DECISION_SUCCESS:
      return {
        ...state,
        pieceDecision: payload,
        okRequest: false,
        loadingData: false
      };

    case actionTypes.GET_DECISION_FAIL:
      return {
        ...state,
        loadingData: false
      };
    case actionTypes.GET_DECISIONS_LIST:
      return {
        ...state,
        decisionsList: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_DECISIONS_LIST_SUCCESS:
      return {
        ...state,
        decisionsList: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_DECISIONS_LIST_FAIL:
      return {
        ...state,
        decisionsList: {
          ...state.decisionsList,
          loading: false
        }
      };
    case actionTypes.SET_HOLD_ON_SUCCESS:
      return {
        ...state,
        okHoldOn: true
      };
    case actionTypes.SAVE_DECISION_SUCCESS:
      return {
        ...state,
        okSave: true
      };
    case actionTypes.DECLINE_DECISION_SUCCESS:
      return {
        ...state,
        okDecline: true
      };
    case actionTypes.ACCEPT_DECISION_SUCCESS:
      return {
        ...state,
        okAccept: true
      };
    default:
      return state;
  }
};

export default reducer;
